module.exports = __webpack_public_path__ + "static/img/05.6fae223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/thuer/05.jpg
// module id = 460
// module chunks = 1